/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Computed membership status for the current season.
 * @export
 */
export const MembershipStatus = {
    Active: 'active',
    Expired: 'expired',
    None: 'none'
};
export function instanceOfMembershipStatus(value) {
    for (const key in MembershipStatus) {
        if (Object.prototype.hasOwnProperty.call(MembershipStatus, key)) {
            if (MembershipStatus[key] === value) {
                return true;
            }
        }
    }
    return false;
}
export function MembershipStatusFromJSON(json) {
    return MembershipStatusFromJSONTyped(json, false);
}
export function MembershipStatusFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function MembershipStatusToJSON(value) {
    return value;
}
export function MembershipStatusToJSONTyped(value, ignoreDiscriminator) {
    return value;
}
